import * as yup from 'yup';
import { commonRules } from '../rules';

export const loginFormValidationSchema = yup.object().shape({
  email: commonRules.email(),
  password: commonRules.password,
});
